import React from 'react';
import {
  Card, CardContent, CardLayout, Link,
} from '@americanexpress/dls-react';
import { IconGuide } from '@americanexpress/dls-icons';
import styles from './ExploreMore.css';
import { ExploreMoreArticleData } from '../../types/PersonalizedMarketingArticles';

type ExploreMoreProps = {
  article: ExploreMoreArticleData
  triggerOnClickAnalytics: () => void
}

export const ExploreMore = ({
  article
}: ExploreMoreProps) => (
  <Card id={article.id} className="height-full pad-0">
    <CardLayout className="pad-3-lr pad-2-b flex-item-grow">
      <CardContent
        className="text-wrap pad-0-tb flex-item-grow"
      >
        {article.icon === "guide" && <div className={styles.customIconSize}>
          <IconGuide size="xl" className="height-full pad-2-t" />
        </div>}
        <div>
          <p className="text-typography-body-2 color-typography-primary margin-0-b">
            {article.body}
          </p>
        </div>
        <div className="pad-3-b pad-3-r position-absolute-br">
          <Link
            href={article.ctaDestination}
            className="text-typography-body-2 font-weight-medium"
            reactlytics={{
              disable: true,
            }}
          >
            {article.ctaLabel}
          </Link>
        </div>
      </CardContent>
    </CardLayout>
  </Card>
);
